/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { validation } from '@insticator/insticator-ui'; // iui-utils



/* --------------- UTILITIES : VALIDATION --------------- */
const uniqueValidation = {
    // +++ STANDARD VALIDATION +++ //
    ...validation,
	

    // +++ PAYMENT +++ //
    paypalUserName:{
        test: /^(?!\s)(?=[\S\s]{2,150}$)[\S\s]*/, 
        message: 'You need to enter a valid PayPal user name'
	},
    bankName:{
        test: /^(?!\s)(?=[\S\s]{2,150}$)[\S\s]*/, 
        message: 'Please enter a valid bank name'
	},
    accountName:{
        test: /^(?!\s)(?=[\S\s]{2,150}$)[\S\s]*/, 
        message: 'Please enter a valid account/company name'
	},
    routingNumber:{
        test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/, 
		message: 'Please enter a valid routing number'
	},
    routingCode:{
        test: /^(?!\s)(?=[\S\s]{2,150}$)[\S\s]*/, 
        message: 'Please enter a valid routing code'
    },
    accountNumber:{
        test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/, 
        message: 'Please enter a valid account number'
	},
	bankAddress:{
        test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/, 
        message: 'You need to enter a valid address'
	},
  bankStreetAddress:{
      test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/, 
      message: 'You need to enter a valid address'
  },
    bankCity: {
        test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/, 
        message: 'Please enter a valid city'
    },
	bankState: {
        test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/, 
        message: 'Please enter a valid state'
    },
  bankRegion: {
      test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/, 
      message: 'Please enter a valid state'
  },
	bankZip: {
        test:  /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,12}$/, 
        message: 'Please enter a valid zip code'
    },
  bankZipCode: {
      test:  /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,12}$/, 
      message: 'Please enter a valid zip code'
  },
	bankCountry: {
        test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/, 
        message: 'Please enter a valid country'
    },
	swift:{
        test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,20}$/,  
        message: 'Please enter a valid SWIFT'
	},
    iban:{
        test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/, ///^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,20}$/, 
        message: 'Please enter a valid IBAN'
    },
	payTo:{
        test: /^(?!\s)[a-zA-Z ]{2,150}$/, 
        message: 'Please enter a valid name'
	},
	paymentAddress:{
        test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/, 
        message: 'You need to enter a valid address'
	},
  paymentStreetAddress:{
      test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/, 
      message: 'You need to enter a valid address'
  },

	zipCode: {
      test:  /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,12}$/, 
      message: 'Please enter a valid zip code'
  },

    // +++ REPORTS +++ //
    reportName: {
        test: /^(?!\s)[A-Za-z0-9'\-\s]{2,150}$/, 
        message: 'A report name is required.'
    },


    // +++ EMBEDS +++ //
	embedname: {
		test: /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]{0,150}$/,
		message: 'Please enter a valid embed name'
	},
    storyURL: {
        test: /^http(s)?:\/\/(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)+\.*[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
        message: 'Format should be http://www.sample.com'
    },

    // +++ COMMENTING ACCOUNT +++ //
    commentingUsername: {
        test: /^(?!\s)[A-Za-z0-9_]{2,16}$/,
        message: 'Username can only contain alphanumeric characters or an underscore'
    },
    userEmail:{
        test: /^(\w{1}[-._! #$%&'*+=?^`{|\w]{0,62}\w{1}@\w[-._\w]*\w\.\w{2,10})$/,
        message: 'Please enter a valid email address'
    },

    // +++ COMMENTING ROLES +++ //
    roleName: {
        test: /^[a-zA-Z\s]+$/,
        message: 'Role name should only contain letters and spaces'
    },
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { uniqueValidation as validation };
